import { reactive, toRefs } from 'vue';
let data = reactive({
    formulId: undefined,//配方id
    standardSamplingInfo: [], //标准样取色信息
    dyeSamplingInfo: [], //染色样取色信息
    dyeColorDiffTable: [], //染色样色差值表格
    illuminantIds: [],//光源
    products: [],//染色液配方
    fabricInfo: {},//织物信息
    fabricId: undefined,//织物id
    fabricKind: undefined,//织物kind
    fabricName: undefined,//织物名
    clothKindId: undefined,
    gramWeightId: undefined,
    processId: undefined,
    bathRatioId: undefined,
    equipmentId: undefined,//精明配色标识id
    equipmentName: undefined,//精明配色标识名
})
const methods = {
    init() {
        console.log('1111111')
        data.formulId = undefined
        data.standardSamplingInfo = []
        data.dyeSamplingInfo = []
        data.dyeColorDiffTable = []
        data.illuminantIds = []
        data.products = []
        data.fabricId = undefined
        data.fabricName = undefined
        data.fabricInfo = {}
        data.equipmentId = undefined
        data.equipmentName = undefined
        data.clothKindId = undefined
        data.gramWeightId = undefined
        data.bathRatioId = undefined
        data.processId = undefined
        data.deyArr = undefined
    }
}
export default {
    data,
    ...toRefs(data),
    ...methods,
}
